/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PlanType_
///   This is an auto-generated enumeration of the SWFC_StockPlan.Core.PlanType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PlanType_ {
   /// <summary>
   ///   Ownership (Own)
   /// </summary>
   Ownership = 1,
   /// <summary>
   ///   Option (Opt)
   /// </summary>
   Option = 2,
   /// <summary>
   ///   Special (Spe)
   /// </summary>
   Special = 3,
   /// <summary>
   ///   87 Option (87 Opt)
   /// </summary>
   _87Option = 4,
   /// <summary>
   ///   Purchase (Purch)
   /// </summary>
   Purchase = 5,
   /// <summary>
   ///   Incentive Option (Incent)
   /// </summary>
   Incentive = 6,
   /// <summary>
   ///   Special 2 (Spe2)
   /// </summary>
   Special2 = 8,
   /// <summary>
   ///   Option 2022 (Opt 2022)
   /// </summary>
   Option2022 = 9
}

export const PlanTypes: PlanType[] = [
   {
      code: PlanType_.Ownership,
      literal: 'Ownership',
      description: 'Ownership',
      shortDescription: 'Own',
      listPriority: 1,

      yearSpan: 2,

      purchaseYearsSkipped: null,

      evergreenSplit: 0.00,

      evergreenInitialVest: 0.00,

      evergreenVestSchedule: 0.00,

      evergreenVestBegin: 0,

      typeName: "PlanType"
   },
   {
      code: PlanType_.Option,
      literal: 'Option',
      description: 'Option',
      shortDescription: 'Opt',
      listPriority: 2,

      yearSpan: 10,

      purchaseYearsSkipped: null,

      evergreenSplit: 0.50,

      evergreenInitialVest: 0.10,

      evergreenVestSchedule: 0.10,

      evergreenVestBegin: 1,

      typeName: "PlanType"
   },
   {
      code: PlanType_.Special,
      literal: 'Special',
      description: 'Special',
      shortDescription: 'Spe',
      listPriority: 3,

      yearSpan: 10,

      purchaseYearsSkipped: null,

      evergreenSplit: 1.00,

      evergreenInitialVest: 0.50,

      evergreenVestSchedule: 0.10,

      evergreenVestBegin: 5,

      typeName: "PlanType"
   },
   {
      code: PlanType_._87Option,
      literal: '_87Option',
      description: '87 Option',
      shortDescription: '87 Opt',
      listPriority: 5,

      yearSpan: 4,

      purchaseYearsSkipped: null,

      evergreenSplit: 1.00,

      evergreenInitialVest: 0.25,

      evergreenVestSchedule: 0.25,

      evergreenVestBegin: 1,

      typeName: "PlanType"
   },
   {
      code: PlanType_.Purchase,
      literal: 'Purchase',
      description: 'Purchase',
      shortDescription: 'Purch',
      listPriority: 6,

      yearSpan: 2,

      purchaseYearsSkipped: null,

      evergreenSplit: 0.00,

      evergreenInitialVest: 0.00,

      evergreenVestSchedule: 0.00,

      evergreenVestBegin: 0,

      typeName: "PlanType"
   },
   {
      code: PlanType_.Incentive,
      literal: 'Incentive',
      description: 'Incentive Option',
      shortDescription: 'Incent',
      listPriority: 7,

      yearSpan: 2,

      purchaseYearsSkipped: null,

      evergreenSplit: 0.00,

      evergreenInitialVest: 0.00,

      evergreenVestSchedule: 0.00,

      evergreenVestBegin: 0,

      typeName: "PlanType"
   },
   {
      code: PlanType_.Special2,
      literal: 'Special2',
      description: 'Special 2',
      shortDescription: 'Spe2',
      listPriority: 4,

      yearSpan: 10,

      purchaseYearsSkipped: null,

      evergreenSplit: 1.00,

      evergreenInitialVest: 0.50,

      evergreenVestSchedule: 0.10,

      evergreenVestBegin: 5,

      typeName: "PlanType"
   },
   {
      code: PlanType_.Option2022,
      literal: 'Option2022',
      description: 'Option 2022',
      shortDescription: 'Opt 2022',
      listPriority: 5,

      yearSpan: 4,

      purchaseYearsSkipped: '2,3',

      evergreenSplit: 0.00,

      evergreenInitialVest: 0.00,

      evergreenVestSchedule: 0.00,

      evergreenVestBegin: 0,

      typeName: "PlanType"
   }
]

export class PlanType implements IDomainModel {
   code: PlanType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   yearSpan: number

   purchaseYearsSkipped: string

   evergreenSplit: number

   evergreenInitialVest: number

   evergreenVestSchedule: number

   evergreenVestBegin: number

   typeName: string

   static toDomainModel(code: PlanType_): PlanType {
      return PlanTypes.find(d => d.code === code)
   }
}
